module.exports = __webpack_public_path__ + "img/finish.dd703ad7.png";